/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PhoneNumber } from './PhoneNumber';
import {
    PhoneNumberFromJSON,
    PhoneNumberFromJSONTyped,
    PhoneNumberToJSON,
    PhoneNumberToJSONTyped,
} from './PhoneNumber';

/**
 * person data (from portal) of appointment
 * @export
 * @interface PersonPortal
 */
export interface PersonPortal {
    /**
     * the lastname of person portal
     * @type {string}
     * @memberof PersonPortal
     */
    lastname?: string;
    /**
     * the firstname of person portal
     * @type {string}
     * @memberof PersonPortal
     */
    firstname?: string;
    /**
     * he email of person portal
     * @type {string}
     * @memberof PersonPortal
     */
    email?: string;
    /**
     * 
     * @type {PhoneNumber}
     * @memberof PersonPortal
     */
    phoneNumber?: PhoneNumber;
    /**
     * Portal user CNS number
     * @type {string}
     * @memberof PersonPortal
     */
    nationalIdentityNumber?: string;
}

/**
 * Check if a given object implements the PersonPortal interface.
 */
export function instanceOfPersonPortal(value: object): value is PersonPortal {
    return true;
}

export function PersonPortalFromJSON(json: any): PersonPortal {
    return PersonPortalFromJSONTyped(json, false);
}

export function PersonPortalFromJSONTyped(json: any, ignoreDiscriminator: boolean): PersonPortal {
    if (json == null) {
        return json;
    }
    return {
        
        'lastname': json['lastname'] == null ? undefined : json['lastname'],
        'firstname': json['firstname'] == null ? undefined : json['firstname'],
        'email': json['email'] == null ? undefined : json['email'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : PhoneNumberFromJSON(json['phoneNumber']),
        'nationalIdentityNumber': json['nationalIdentityNumber'] == null ? undefined : json['nationalIdentityNumber'],
    };
}

export function PersonPortalToJSON(json: any): PersonPortal {
    return PersonPortalToJSONTyped(json, false);
}

export function PersonPortalToJSONTyped(value?: PersonPortal | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lastname': value['lastname'],
        'firstname': value['firstname'],
        'email': value['email'],
        'phoneNumber': PhoneNumberToJSON(value['phoneNumber']),
        'nationalIdentityNumber': value['nationalIdentityNumber'],
    };
}

